export default __webpack_public_path__ + "static/media/icon-receita.e56706d2.svg";